export const suffix = ['JR', 'SR', '1ST', '2ND', '3RD', '4TH', '5TH', '6TH', '7TH', '8TH', '9TH']
export const stagingState = [
    {
      "code": "AL",
      "label": "Alabama"
    },
    {
      "code": "AK",
      "label": "Alaska"
    },
    {
      "code": "AZ",
      "label": "Arizona"
    },
    {
      "code": "AR",
      "label": "Arkansas"
    },
    {
      "code": "CA",
      "label": "California"
    },
    {
      "code": "CO",
      "label": "Colorado"
    },
    {
      "code": "CT",
      "label": "Connecticut"
    },
    {
      "code": "DE",
      "label": "Delaware"
    },
    {
      "code": "DC",
      "label": "District of Columbia"
    },
    {
      "code": "FL",
      "label": "Florida"
    },
    {
      "code": "GA",
      "label": "Georgia"
    },
    {
      "code": "HI",
      "label": "Hawaii"
    },
    {
      "code": "ID",
      "label": "Idaho"
    },
    {
      "code": "IL",
      "label": "Illinois"
    },
    {
      "code": "IN",
      "label": "Indiana"
    },
    {
      "code": "IA",
      "label": "Iowa"
    },
    {
      "code": "KS",
      "label": "Kansas"
    },
    {
      "code": "KY",
      "label": "Kentucky"
    },
    {
      "code": "LA",
      "label": "Louisiana"
    },
    {
      "code": "ME",
      "label": "Maine"
    },
    {
      "code": "MD",
      "label": "Maryland"
    },
    {
      "code": "MA",
      "label": "Massachusetts"
    },
    {
      "code": "MI",
      "label": "Michigan"
    },
    {
      "code": "MN",
      "label": "Minnesota"
    },
    {
      "code": "MS",
      "label": "Mississippi"
    },
    {
      "code": "MO",
      "label": "Missouri"
    },
    {
      "code": "MT",
      "label": "Montana"
    },
    {
      "code": "NE",
      "label": "Nebraska"
    },
    {
      "code": "NV",
      "label": "Nevada"
    },
    {
      "code": "NH",
      "label": "New Hampshire"
    },
    {
      "code": "NJ",
      "label": "New Jersey"
    },
    {
      "code": "NM",
      "label": "New Mexico"
    },
    {
      "code": "NY",
      "label": "New York"
    },
    {
      "code": "NC",
      "label": "North Carolina"
    },
    {
      "code": "ND",
      "label": "North Dakota"
    },
    {
      "code": "OH",
      "label": "Ohio"
    },
    {
      "code": "OK",
      "label": "Oklahoma"
    },
    {
      "code": "OR",
      "label": "Oregon"
    },
    {
      "code": "PA",
      "label": "Pennsylvania"
    },
    {
      "code": "RI",
      "label": "Rhode Island"
    },
    {
      "code": "SC",
      "label": "South Carolina"
    },
    {
      "code": "SD",
      "label": "South Dakota"
    },
    {
      "code": "TN",
      "label": "Tennessee"
    },
    {
      "code": "TX",
      "label": "Texas"
    },
    {
      "code": "UT",
      "label": "Utah"
    },
    {
      "code": "VT",
      "label": "Vermont"
    },
    {
      "code": "VA",
      "label": "Virginia"
    },
    {
      "code": "WA",
      "label": "Washington"
    },
    {
      "code": "WV",
      "label": "West Virginia"
    },
    {
      "code": "WI",
      "label": "Wisconsin"
    },
    {
      "code": "WY",
      "label": "Wyoming"
    }]
const ACTIONS_DEFAULT = [
    { code: "1", label: "Revoked" },
    { code: "2", label: "Barred" },
    { code: "3", label: "Suspended" },
    { code: "4", label: "Canceled" },
    { code: "5", label: "Denied" },
    { code: "6", label: "Disqualified" },
    { code: "7", label: "Other Withdrawal" }
];

const BASIS_DEFAULT = [
    { code: "0", label: "Unknown" },
    { code: "1", label: "Conviction" },
    { code: "2", label: "Administrative Adjudication" },
    { code: "3", label: "Administrative Action" },
    { code: "4", label: "Repeated Violations" },
    { code: "5", label: "Withdrawal resulting from point system" },
    { code: "6", label: "Court ordered or requested" },
    { code: "7", label: "Court recommended" },
    { code: "8", label: "NRVC Action or Reciprocity" },
    { code: "9", label: "Administrative Per Se" }
];

const DUE_PROCESS_DEFAULT = [
    { code: "0", label: "Not defined" },
    { code: "1", label: "Hearing held; action confirmed" },
    { code: "2", label: "Hearing offered but not requested" },
    { code: "3", label: "Hearing requested; not yet held  - Held - acceptable" },
    { code: "4", label: "Department action appealed to court" },
    { code: "5", label: "Hearing not applicable" }
];

const EXTENT_DEFAULT = [
    { code: "1", label: "Commercial" },
    { code: "2", label: "Permit" },
    { code: "3", label: "All" },
    { code: "4", label: "Non-CDL" }
];

export const actions = {
    DEFAULT: ACTIONS_DEFAULT,
    MI: ACTIONS_DEFAULT.filter(opt => opt.code !== "2"), // MI omits "Barred"
    OR: ACTIONS_DEFAULT.filter(opt => ["1", "3", "4"].includes(opt.code)), // OR only has "Revoked", "Suspended", "Canceled"
};

export const basis = {
    DEFAULT: BASIS_DEFAULT,
    OR: BASIS_DEFAULT.filter(opt => ["1", "2", "3", "5", "6", "9"].includes(opt.code)),
};

export const dueProcess = {
    DEFAULT: DUE_PROCESS_DEFAULT,
    OR: DUE_PROCESS_DEFAULT.filter(opt => opt.code === "0"),
    MI: DUE_PROCESS_DEFAULT.filter(opt => ["0", "4"].includes(opt.code)),
};

export const extent = {
    DEFAULT: EXTENT_DEFAULT,
};

